import { render, staticRenderFns } from "./UserDetailPopup.vue?vue&type=template&id=e027fea0&scoped=true&lang=pug&"
import script from "./UserDetailPopup.vue?vue&type=script&lang=js&"
export * from "./UserDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPopup.vue?vue&type=style&index=0&id=e027fea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e027fea0",
  null
  
)

export default component.exports